module.exports = __webpack_public_path__ + "static/media/24.59a6e6f9.jpg";